import CityZoneHub from '../components/CityZoneHub';

export default function SanPedroDeAlcantaraPage() {
  return (
    <CityZoneHub
      slug="san-pedro-de-alcantara"
      name="San Pedro de Alcántara"
      heroSubtitle="Cubrimos todo San Pedro: centro histórico, Guadalmina, Linda Vista, bulevar."
      barrios={["Centro histórico", "Guadalmina", "Linda Vista", "Cancelada", "Nueva Alcántara"]}
      faqItems={[]}
    />
  );
}